<template>
  <bk-page class="komoRootPage" @close="closeBtnClick">

<!--    <bk-view class="view-router">-->

<!--      &lt;!&ndash;      <transition name="fadeIn" mode="out-in" appear>&ndash;&gt;-->
<!--      &lt;!&ndash;        <router-view pageType="navRoot"></router-view>&ndash;&gt;-->
<!--      &lt;!&ndash;      </transition>&ndash;&gt;-->


<!--      <transition name="fadeIn" mode="out-in">-->
<!--        &lt;!&ndash;          :include="cachedDoms"&ndash;&gt;-->
<!--        <keep-alive :max="5">-->
<!--          <component :is="Component" :pageType="'navRoot'"/>-->
<!--        </keep-alive>-->
<!--      </transition>-->

<!--    </bk-view>-->

    <bk-view class="view-router">

      <!--      <transition name="fadeIn" mode="out-in" appear>-->
      <!--        <router-view pageType="navRoot"></router-view>-->
      <!--      </transition>-->

      <router-view v-slot="{ Component, route }">
        <transition name="fadeIn" mode="out-in">
          <!--          :include="cachedDoms"-->
          <keep-alive :max="5">
            <component :is="Component" :key="route.name" :pageType="route.meta?.pageType || 'navRoot'"/>
          </keep-alive>
        </transition>
      </router-view>
    </bk-view>

    <AppTabs></AppTabs>

  </bk-page>

</template>

<script>

	import AppTabs from './subviews/appTabs/appTabs';

	export default {
		name: 'KomoRoot',
		components: {
			AppTabs
		},
		methods: {
			closeBtnClick () {
				this.$router.replace('/');
			},
		}
	};
</script>

<style lang="less">

.komoRootPage {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  min-height: 100vh;
  height: 100vh;
  background: #fff;

  > .bk-navBar {
    z-index: 100;
    padding-top: 0px !important;

    .btn-close {

      .bk-icon {
        color: #fff !important;
      }
    }
  }

  > .view-router {
    //min-height: 100%;
    height: 100vh;
    overflow-y: auto;
    //overflow-y: scroll;
    padding-bottom: calc(49px + env(safe-area-inset-bottom));
  }
}

</style>
